export const getParamsUrl = (params, obj) => {
	params = Object.keys(params)
		.map((key) => [key] + "=" + encodeURIComponent(obj[params[key]]) + "&")
		.join("");
	params = `?${params.substring(0, params.length - 1)}`;
	return params;
};

export const getParamsFromObj = (params, isStart = true) => {
	params = Object.keys(params)
		.map((key) => [key] + "=" + encodeURIComponent(params[key]) + "&")
		.join("");
	params = `${isStart ? '?': '&'}${params.substring(0, params.length - 1)}`;
	return params;
};
